import { QueuedCheckStatuses } from '@mesa/core/checks';
import { CheckCircle2Icon, CircleSlashIcon, ClockIcon, HourglassIcon, Loader2Icon, XCircleIcon } from 'lucide-react';


export const StatusIcon = ({ status, conclusion }: { status: string; conclusion: string | null }) => {
  if (status === 'IN_PROGRESS') {
    return <Loader2Icon size={14} className="animate-spin text-blue-500" />;
  }

  if (QueuedCheckStatuses.some((queuedStatus) => queuedStatus === status)) {
    return <ClockIcon size={14} className="text-yellow-500" />;
  }

  if (status === 'COMPLETED') {
    if (conclusion === 'SUCCESS') {
      return <CheckCircle2Icon size={14} className="text-green-500" />;
    }

    if (conclusion !== null && ['FAILURE', 'TIMED_OUT', 'ACTION_REQUIRED'].includes(conclusion)) {
      return <XCircleIcon size={14} className="text-red-500" />;
    }

    if (conclusion === 'CANCELLED') {
      return <CircleSlashIcon size={14} className="text-gray-500" />;
    }

    if (conclusion !== null && ['NEUTRAL', 'SKIPPED'].includes(conclusion)) {
      return <HourglassIcon size={14} className="text-gray-400" />;
    }
  }

  return <CircleSlashIcon size={14} className="text-gray-500" />;
};
